import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {Link, useLocation, useParams } from "react-router-dom";
import SEO from "../../components/seo";
import { getDiscountPrice } from "../../helpers/product";
import LayoutTwo from "../../layouts/LayoutTwo";
import { fetchOrder, fetchOrders } from "../../helpers/api/order";
import Stepper from "../../components/stepper/stepper1";

const Order = () => {
  
  let cartTotalPrice = 0;
  const dispatch = useDispatch();
  const currency = useSelector((state) => state.currency);

  let { id } = useParams();
  const { loading, error,order } = useSelector((state) => state.order);

  useEffect(() => {
      dispatch(fetchOrder(id));
  }, [dispatch]);

  // Informasi bank dan auto-text
  const bankInfo = {
    bankName: "CIMB NIAGA",
    accountNumber: "706740883300",
    accountHolder: "Raka Dwiyogo Prakoso"
  };
  // Fungsi untuk menyalin auto-text
  const handleCopyPaymentInfo = () => {
    const paymentText = document.getElementById("note").innerText; // Get the text content of the element with id="note"
    navigator.clipboard.writeText(paymentText);
    alert("Informasi pembayaran telah disalin!");
  };
  const handleCopyBankInfo = () => {
    const paymentText = bankInfo.accountNumber; // Get the text content of the element with id="note"
    navigator.clipboard.writeText(paymentText);
    alert("Informasi Bank telah disalin!");
  };

  return (
    <Fragment>
      <SEO
        titleTemplate={"Order"}
        description="Keeus Order"
      />

      <LayoutTwo>
        <div className="cart-main-area pt-180 pb-100">
          <div className="container">
            {loading ? (
              <div className="h2 text-center">Loading...</div>
            ) : error ? (
              <p>Error: {error}</p>
            ) :order && order !== undefined ? (
              <Fragment>
                <Stepper current_state={order.order_status_id} />
                <h3 className="cart-page-title">{order.name}</h3>
                <div className="row mb-20">
                  <div className="col-12">
                    <div className="table-content table-responsive cart-table-content">
                      <table>
                        <thead>
                          <tr>
                            <th>Image</th>
                            <th>Product Name</th>
                            <th>Unit Price</th>
                            <th>Qty</th>
                            <th>Subtotal</th>
                            {/* <th>action</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {order.product.map((orderItem, key) => {
                            const discountedPrice = getDiscountPrice(
                              orderItem.price,
                              orderItem.discount
                            );
                            const finalProductPrice = (
                              orderItem.price * currency.currencyRate
                            ).toFixed(0);
                            const finalDiscountedPrice = (
                              discountedPrice * currency.currencyRate
                            ).toFixed(0);

                            discountedPrice != null
                              ? (cartTotalPrice +=
                                  finalDiscountedPrice * orderItem.qty)
                              : (cartTotalPrice +=
                                  finalProductPrice * orderItem.qty);
                            return (
                              <tr key={key}>
                                <td className="product-thumbnail">
                                  <Link
                                    to="#"
                                  >
                                    <img
                                      className="img-fluid"
                                      src={
                                        process.env.PUBLIC_URL +
                                        orderItem.image
                                      }
                                      alt=""
                                    />
                                  </Link>
                                </td>

                                <td className="product-name">
                                    {orderItem.name}
                                  {orderItem.topping ? (
                                    <div className="cart-item-variation">
                                      <span>
                                        Topping: {orderItem.topping}
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </td>

                                <td className="product-price-cart">
                                  {discountedPrice !== null ? (
                                    <Fragment>
                                      <span className="amount old">
                                        {currency.currencySymbol +
                                          finalProductPrice}
                                      </span>
                                      <span className="amount">
                                        {currency.currencySymbol +
                                          finalDiscountedPrice}
                                      </span>
                                    </Fragment>
                                  ) : (
                                    <span className="amount">
                                      {currency.currencySymbol +" "+
                                        parseInt(finalProductPrice).toLocaleString()}
                                    </span>
                                  )}
                                </td>

                                <td className="product-quantity">
                                  <div className="cart-plus-minus">
                                    <input
                                      className="cart-plus-minus-box"
                                      type="text"
                                      value={orderItem.qty}
                                      readOnly
                                    />
                                  </div>
                                </td>
                                <td className="product-subtotal">
                                  {discountedPrice !== null
                                    ? currency.currencySymbol +" "+
                                      parseInt((
                                        finalDiscountedPrice * orderItem.qty
                                      ).toFixed(0)).toLocaleString()
                                    : currency.currencySymbol +" "+
                                      parseInt((
                                        finalProductPrice * orderItem.qty
                                      ).toFixed(0)).toLocaleString()}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <div className="grand-totall">
                      <div className="title-wrap">
                        <h4 className="cart-bottom-title section-bg-gary-cart">
                          Order Total
                        </h4>
                      </div>
                      <h5>
                        Total products{" "}
                        <span>
                          {currency.currencySymbol + parseInt(cartTotalPrice.toFixed(0)).toLocaleString()}
                        </span>
                      </h5>
                      {
                        order.discount > 0 && (
                          <h5>
                            Discount{" "}
                            <span className="text-danger">
                              - {currency.currencySymbol + parseInt(order.discount.toFixed(0)).toLocaleString()}
                            </span>
                          </h5>
                        )
                      }

                      <h4 className="grand-totall-title mb-0">
                        Grand Total{" "}
                        <span>
                          {currency.currencySymbol + parseInt((cartTotalPrice-order.discount).toFixed(0)).toLocaleString()}
                        </span>
                      </h4>
                      {/* <Link to={process.env.PUBLIC_URL + "/checkout"}>
                        Proceed to Checkout
                      </Link> */}
                      <div className="d-none" id="note">{`PEMBAYARAN ORDER KEEUS
Kepada: ${order.name}
Terima kasih telah berbelanja di Keeus! Kami sangat senang dapat melayani Anda. 🎉🍫

📄 Detail Pemesanan: https://keeus.id/order/${id}

💸Detail Pembayaran:
CASH / TRANSFER
Bank: ${bankInfo.bankName}
No. Rekening: ${bankInfo.accountNumber}
Atas Nama: ${bankInfo.accountHolder}
Total Pembayaran: ${currency.currencySymbol +" "+ parseInt((order.totalPrice).toFixed(0)).toLocaleString()}

Jika Anda memiliki pertanyaan atau membutuhkan bantuan, jangan ragu untuk menghubungi kami melalui DM Instagram @keeus.id atau chat WhatsApp kami di +62851-6131-6022.
Selamat menikmati brownies lezat dari Keeus, kami tunggu ulasan dari Anda! 🍫❤️`}
                      </div>
                      <div className="title-wrap mt-5">
                        <h4 className="cart-bottom-title section-bg-gary-cart">
                          Informasi Pembayaran
                        </h4>
                      </div>
                      <h5 className="my-0">CASH / BANK</h5>
                      <p className="mb-0">Bank: {bankInfo.bankName}</p>
                      <p className="mb-0">No. Rekening: {bankInfo.accountNumber}</p>
                      <p className="mb-0">Atas Nama: {bankInfo.accountHolder}</p>
                      <button
                        className="btn btn-primary btn-sm mt-3"
                        onClick={handleCopyBankInfo}
                      >
                        Copy Bank Info
                      </button>
                      <button
                        className="btn btn-default btn-sm mt-3"
                        onClick={handleCopyPaymentInfo}
                      >
                        Copy Order Message
                      </button>
                    </div>
                  </div>
                </div>
              </Fragment>
            ) : (
              <div className="row">
                <div className="col-lg-12">
                  <div className="item-empty-area text-center">
                    <div className="item-empty-area__icon mb-30">
                      <i className="pe-7s-cart"></i>
                    </div>
                    <div className="item-empty-area__text">
                      No Orders Found <br />{" "}
                      <Link to={process.env.PUBLIC_URL + "/"}>
                        Back to Home
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </LayoutTwo>
    </Fragment>
  );
};

export default Order;
